import React from 'react';
import { Table } from 'react-bootstrap';

const TableView = ({ products }) => {
  return (
    <Table striped bordered hover className="mt-3">
      <thead>
        <tr>
          <th>Комірка</th>
          <th>Назва букета</th>
          <th>Ціна</th>
          <th>Категорія</th>
          <th>Зображення</th>
          <th>#</th>
        </tr>
      </thead>
      <tbody>
        {products.map((product, index) => (
          <tr key={product.id}>
            <td>{product.name}</td>
            <td>{product.name_byket || '—'}</td>
            <td>{product.price} UAH</td>
            <td>{product.category.name}</td>
            <td>
                {product.image_data ? (
                  <img
                    src={product.image_data}
                    alt={product.name}
                    style={{ maxWidth: '100px', height: 'auto' }}
                  />
                ) : (
                  'Немає зображення'
                )}
              </td>
            <td>{index + 1}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default TableView;
